import type { ReactElement } from "react";
import { Navigate, Outlet, useMatches, useParams } from "react-router-dom";

import { EmbeddedPageSkeleton } from "@/components/skeleton-page/EmbeddedPageSkeleton";
import { useAuth } from "@/hooks/useAuth";
import { can } from "@/lib/permissions";
import { getLeafRoutePermission, resolvePermissionRedirect } from "@/lib/permissionRouting";

export function PermissionGate(): ReactElement {
  const { user, isLoading } = useAuth();
  const matches = useMatches();
  const { projectId } = useParams<{ projectId?: string }>();
  const permission = getLeafRoutePermission(matches);

  if (isLoading) {
    return <EmbeddedPageSkeleton />;
  }

  if (permission && !can(user, permission)) {
    return (
      <>
        <EmbeddedPageSkeleton />
        <Navigate to={resolvePermissionRedirect(user, projectId)} replace />
      </>
    );
  }

  return <Outlet />;
}
